export class FiltroManifestoPorOperadorDTO {

  dataInicial: string;
  dataFinal: string;
  usernameOperador: string;
  nomeOperador: string;
  unidade: string;
  page: number;

  constructor() {

    this.dataInicial = 'null';
    this.dataFinal = 'null';
    this.usernameOperador = null;
    this.nomeOperador = null;
    this.unidade = null;
    this.page = 0;

  }

}
